<div class="loader">
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
  @if (loadingText()) {
    <span class="loader__text">{{ loadingText() }}</span>
  }
</div>
